import Card from "../../components/cards/Card"
import typo from "../../typography.module.css"
import styles from "../Dashboard.module.css"

const DashboardFallback = ({ user }) => {
    return (
        <div className={styles.section}>
            <div className={styles.sectionInner}>
                <div className={typo.title}>Benvenuto, {user?.name ?? ''}</div>
                <Card>
                    <div className={typo.headline}>Nessun contenuto dashboard configurato per questo ruolo.</div>
                </Card>
            </div>
        </div>
    )
}

export default DashboardFallback
